import styled from "styled-components";

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
`;

export const SmallColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
`;

export const Row = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;
